/**
 * sessionOutcome — FW-200. GET /api/v1/auth/session sözleşmesi
 * apps/auth/src/composables/useSession.ts'ten BİREBİR alınır (aynı backend,
 * aynı uç). apps/console/src/domain/sessionOutcome.ts ile AYNI desen; tek
 * fark apps/app'in bir ROL şartı (System_Admin gibi) OLMAMASI — bu yüzey
 * için "oturum var mı" yeterli, kurulumun TAMAMLANIP TAMAMLANMADIĞI ayrı bir
 * soru (bkz. `hasCompletedOnboarding` + router/onboardingGuard.ts).
 *
 * ÖLÇÜM SINIRI / VARSAYIM (FW-200 raporunda açıkça belirtilir): backend'de
 * "onboarding tamamlandı mı" için AYRI bir alan/uç YOK — kilitli sözleşmede
 * yalnız POST /api/v1/onboarding/submit'in "Başarıda token yenilenir
 * (tenant_id + Tenant_Owner)" cümlesi var. Bu yüzden tamamlanma sinyali
 * olarak session'ın `tenantId`'sinin DOLU olması kullanılıyor (submit'ten
 * ÖNCE kullanıcının henüz bir kiracısı yok varsayımı). Bu bir ÖLÇÜM değil
 * VARSAYIMDIR — gerçek backend davranışıyla doğrulanmadı.
 *
 * Kasıtlı olarak SAF fonksiyon: `ApiClient` dışarıdan verilir, Vue'nin
 * `inject()`'ine BAĞLI DEĞİLDİR — bileşen ağacının içinde
 * (useCurrentSession üzerinden) VE dışında (router guard, main.ts) AYNI kod
 * kullanılır.
 */
import { ApiError, type ApiClient } from '@fusapp-work/api'

export interface SessionResponse {
  readonly tenantId: string
  readonly userId: string
  readonly email: string | null
  readonly name: string | null
  readonly roles: readonly string[]
}

export type SessionOutcome =
  | { readonly kind: 'authenticated'; readonly session: SessionResponse }
  | { readonly kind: 'unauthenticated' }
  | { readonly kind: 'error'; readonly message: string }

export async function resolveSessionOutcome(apiClient: ApiClient): Promise<SessionOutcome> {
  try {
    const session = await apiClient.request<SessionResponse>('/api/v1/auth/session', { method: 'GET' })
    return { kind: 'authenticated', session }
  } catch (error) {
    if (error instanceof ApiError && error.status === 401) {
      return { kind: 'unauthenticated' }
    }
    return { kind: 'error', message: error instanceof Error ? error.message : 'unknown error' }
  }
}

/** Bkz. dosya başlığındaki "ÖLÇÜM SINIRI / VARSAYIM" notu. */
export function hasCompletedOnboarding(session: SessionResponse): boolean {
  return session.tenantId.trim() !== ''
}
